// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activitiesSection {
  position: relative;
  padding: 2em 0;
}

.activitiesSection__title {
  font-size: 1.5rem;
  color: var(--clr-gray800);
  white-space: nowrap;
}

.activitiesSection__pagination {
  display: none;
  margin-top: 2.5rem;
  width: 100%;
}
.activitiesSection__paginationProgressContainer {
  margin-inline: auto;
}
.activitiesSection__paginationProgressBar,
.activitiesSection__paginationProgressContainer {
  width: 100%;
  max-width: 6.25rem;
  height: 0.5rem;
  border-radius: 3em;
  position: relative;
  background: var(--clr-gray500);
}

.activitiesSection__paginationProgressBar {
  width: 20%;
  position: absolute;
  left: 0;
  top: 0;
  background: var(--clr-gray800);
}

.activitiesSection__btnNav {
  display: none;
  place-items: center;
  padding: 0;
  width: 3rem;
  height: 3rem;
  top: 52.5%;
  transform: translateY(-50%);
  position: absolute;
}

.activitiesSection__btnNav.right {
  right: -5rem;
}
.activitiesSection__btnNav.left {
  left: -5rem;
}
.activitiesSection__btnNav.left svg {
  transform: rotate(180deg);
}

.activitiesSection__container {
  display: grid;
  gap: 1.5rem;
  margin-top: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
}

.activitiesSection__seeMore {
  display: grid;
  place-items: flex-end;
  text-transform: uppercase;
  color: var(--clr-primary);
  margin-top: 1rem;
  font-size: 0.9rem;
}

@media (min-width: 375px) {
  .activitiesSection__container {
    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  }

  .activitiesSection__title {
    font-size: 1.8rem;
  }
}

@media (min-width: 768px) {
  .activitiesSection__title {
    font-size: 2rem;
  }
}

@media (min-width: 992px) {
  .activitiesSection__seeMore {
    display: none;
  }
  .activitiesSection__btnNav {
    display: grid;
  }

  .activitiesSection__pagination {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActivitiesComponent/ActivitiesSection/ActivitiesSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".activitiesSection {\n  position: relative;\n  padding: 2em 0;\n}\n\n.activitiesSection__title {\n  font-size: 1.5rem;\n  color: var(--clr-gray800);\n  white-space: nowrap;\n}\n\n.activitiesSection__pagination {\n  display: none;\n  margin-top: 2.5rem;\n  width: 100%;\n}\n.activitiesSection__paginationProgressContainer {\n  margin-inline: auto;\n}\n.activitiesSection__paginationProgressBar,\n.activitiesSection__paginationProgressContainer {\n  width: 100%;\n  max-width: 6.25rem;\n  height: 0.5rem;\n  border-radius: 3em;\n  position: relative;\n  background: var(--clr-gray500);\n}\n\n.activitiesSection__paginationProgressBar {\n  width: 20%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: var(--clr-gray800);\n}\n\n.activitiesSection__btnNav {\n  display: none;\n  place-items: center;\n  padding: 0;\n  width: 3rem;\n  height: 3rem;\n  top: 52.5%;\n  transform: translateY(-50%);\n  position: absolute;\n}\n\n.activitiesSection__btnNav.right {\n  right: -5rem;\n}\n.activitiesSection__btnNav.left {\n  left: -5rem;\n}\n.activitiesSection__btnNav.left svg {\n  transform: rotate(180deg);\n}\n\n.activitiesSection__container {\n  display: grid;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n}\n\n.activitiesSection__seeMore {\n  display: grid;\n  place-items: flex-end;\n  text-transform: uppercase;\n  color: var(--clr-primary);\n  margin-top: 1rem;\n  font-size: 0.9rem;\n}\n\n@media (min-width: 375px) {\n  .activitiesSection__container {\n    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n  }\n\n  .activitiesSection__title {\n    font-size: 1.8rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .activitiesSection__title {\n    font-size: 2rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .activitiesSection__seeMore {\n    display: none;\n  }\n  .activitiesSection__btnNav {\n    display: grid;\n  }\n\n  .activitiesSection__pagination {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
